import React from "react";
import { Wrapper } from "../../GlobalStyle";
import { FooterWrapper } from "./Styled";

import Logo from '../../images/logo.png';

function Footer() {
  return (
    <FooterWrapper>
      <Wrapper>
          <div>
             <img src={Logo} alt="Seedverse" />
          </div>
        <div>
          250 Orchard Rd, Singapore 238905 |{" "}
          <a href={"mailto:seedverse@smaths.com"}>seedverse@smaths.com</a>
        </div>
      </Wrapper>
    </FooterWrapper>
  );
}

export default Footer;
